export default __webpack_public_path__ + "static/media/9.fbc048d8.jpeg";